import TooltipComponent from "./TooltipComponent";

const TextBox = (props) => {
    return (
        <div>
            <label htmlFor={`${props.id}`} className="form-label">{props.label}</label>
            <input className="form-control" value={props.value} type={props.type} id={props.id} name={props.name} placeholder={props.hint} onChange={props.change} />
        </div>
    );
}

const TextArea = (props) => {

    return (
        <div>
            <label htmlFor="basiInput" className="form-label">{props.label}</label>
            <textarea className="form-control" value={props.value} type={props.type} id={props.id} name={props.name} placeholder={props.hint} onChange={props.change} />
        </div>
    );
}
const SubmitBtn = (props) => {
    return (
        props.status === true ? <button type="button" class={`btn btn-${props.type} btn-load`}><span class="d-flex align-items-center"><span class="flex-grow-1 me-2">Please wait...</span><span class="spinner-grow flex-shrink-0" role="status"><span class="visually-hidden">Please wait...</span></span></span></button>
            : <button type="submit" className={`btn btn-${props.type} btn-label waves-effect right waves-light float-right`}><i className={`${props.icon} label-icon align-middle fs-16 ms-2`} /> {props.text}</button>
    );
}
const SubmitButton = (props) => {
    const handleClick = (event) => {
      if (props.onClick) {
        props.onClick(event);
      }
    };
    // props.loading => Used for show loading
    // props.loadingMessage => Used for show message text while loading
    // props.type => Used for set color of button
    // props.otherClasses  => Used for add other css classes
    return props.loading === true ? (
      <button type="button" className={`btn btn-${props.type} ${props.otherClasses} btn-load`}>
        <span className="d-flex align-items-center">
          {/* props.loadingCss => this us used for add external css classes to make adjust size of loader */}
          <span class={`spinner-border flex-shrink-0 ${props.loadingCss} `} role="status">
            <span class="visually-hidden">{props.loadingMessage}...</span>
          </span>
          <span className="flex-grow-1 me-2 ps-1">{props.loadingMessage}...</span>
        </span>
      </button>
    ) : (
      <button
        type="submit"
        disabled={props.disabled}
        className={`btn btn-${props.type} ${props.otherClasses} btn-label waves-effect ${props.iconSide} waves-light float-${props.float}`}
        onClick={handleClick}
      >
        <i className={`${props.icon} label-icon align-middle fs-16`} />
        <span className="flex-grow-1 me-2">{props.buttonName}</span>
      </button>
    );
};
const IconButton = (props) => {
    const handleClick = (event) => {
      if (props.onClick) {
        props.onClick(event);
      }
    };
  
    return props.tooltipName && props.tooltipPosition ?
      (
        <TooltipComponent name={props.tooltipName} position={props.tooltipPosition}>
        <button
          disabled={props.disabled}
          onClick={()=> {if(!props.loading) handleClick();}}
          type="button"
          className={`btn-icon btn btn-sm btn-outline-${props.type}`}
        >
          {props.loading ? (
            <span class="spinner-border flex-shrink-0 smallLoader" role="status">
              <span class="visually-hidden">
                Loading...
              </span>
            </span>
          ) : (
            <i className={props.icon}></i>
          )}
        </button>
        </TooltipComponent>
      ):
      (
        <button
          disabled={props.disabled}
          onClick={()=> {if(!props.loading) handleClick();}}
          type="button"
          className={`btn-icon btn btn-sm btn-outline-${props.type}`}
        >
          {props.loading ? (
            <span class="spinner-border flex-shrink-0 smallLoader" role="status">
              <span class="visually-hidden">
                Loading...
              </span>
            </span>
          ) : (
            <i className={props.icon}></i>
          )}
        </button>
    )
  };
  
const IsRequired = () => {
    return (
        <span style={{ color: 'blue', marginLeft: 5, borderRadius: '50%', background: 'rgb(240, 248, 255)', textAlign: 'center', width: 20, height: 20, padding: '0px 5px' }}>*</span>
    );
}
const formatDate = (GettedDate) => {
  if (!GettedDate) {
    return ``;
  }

  if (GettedDate instanceof Date && !isNaN(GettedDate.getTime())) {
    return formatValidDate(GettedDate);
  }

  let date;

  if (typeof GettedDate === "string" && GettedDate.includes(" ")) {
    GettedDate = GettedDate.split(" ")[0]; 
  }

  if (/^\d{4}-\d{2}-\d{2}$/.test(GettedDate)) {
    date = new Date(GettedDate);
  } 

  else if (/^\d{2}-\d{2}-\d{4}$/.test(GettedDate)) {
    const [day, month, year] = GettedDate.split("-").map(Number);
    date = new Date(`${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`);
  }

  if (date instanceof Date && !isNaN(date.getTime())) {
    return formatValidDate(date);
  }

  return ``; 
};

const formatValidDate = (date) => {
  const monthNames = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

  const day = date.getDate();
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();

  return `${day.toString().padStart(2, '0')}-${month}-${year}`;
};

const formatTime = (datetimeString) => {
    if (!datetimeString) {
        return "";
    }
    var timeString = datetimeString?.split(' ')[1];
    if(timeString){
        var timeComponents = timeString?.split(':');
        var hours = parseInt(timeComponents[0]);
        var minutes = parseInt(timeComponents[1]);
        var meridiem = (hours < 12) ? 'AM' : 'PM';
        hours = (hours % 12 === 0) ? 12 : hours % 12;
        if (minutes < 10) {
            minutes = '0' + minutes;
        }
        var formattedTime = hours + ':' + minutes + ' ' + meridiem;
        return formattedTime;
    }
    else{
        timeString = datetimeString?.split('T')[1];
        var timeComponents = timeString?.split(':');
        var hours = parseInt(timeComponents[0]);
        var minutes = parseInt(timeComponents[1]);
        var meridiem = (hours < 12) ? 'AM' : 'PM';
        hours = (hours % 12 === 0) ? 12 : hours % 12;
        if (minutes < 10) {
            minutes = '0' + minutes;
        }
        var formattedTime = hours + ':' + minutes + ' ' + meridiem;
        return formattedTime;
    }
    
}

// get month year fromat
const formatMonthYear = (monthYear) => {
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", 
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  // Check if input is already in correct format (e.g., "Jan-2025")
  if (/^[A-Za-z]{3}-\d{4}$/.test(monthYear)) {
      return monthYear; // Return as is if it matches "Jan-YYYY" format
  }

  // Check for "Jan-25" and convert it to "Jan-2025"
  const shortYearMatch = monthYear.match(/^([A-Za-z]{3})-(\d{2})$/);
  if (shortYearMatch) {
      const [_, monthStr, shortYear] = shortYearMatch;
      if (monthNames.includes(monthStr)) {
          return `${monthStr}-20${shortYear}`;
      }
      return ""; // Invalid month abbreviation
  }

  // Check if the input is in "M-YYYY" or "MM-YYYY" numeric format
  const parts = monthYear.split('-');
  if (parts.length !== 2 || isNaN(parts[0]) || isNaN(parts[1])) {
      return ""; // Invalid format
  }

  const [month, year] = parts.map(Number);
  
  // Validate month and year range
  if (month < 1 || month > 12 || year < 0 || year > 99 && year < 1000 || year > 9999) {
      return ""; // Invalid month or year
  }

  // Convert 2-digit year to 4-digit (assume 2000+)
  const fullYear = year < 100 ? 2000 + year : year;

  return `${monthNames[month - 1]}-${fullYear}`;
};

const convertTo12HourFormat = (datetimeString) => {
    if (!datetimeString) {
        return "";
    }

    var timeComponents = datetimeString.split(':');
    var hours = parseInt(timeComponents[0]);
    var minutes = parseInt(timeComponents[1]);
    var meridiem = (hours < 12) ? 'AM' : 'PM';
    hours = (hours % 12 === 0) ? 12 : hours % 12;
    if (minutes < 10) {
        minutes = '0' + minutes;
    }
    var formattedTime = hours + ':' + minutes + ' ' + meridiem;

    return formattedTime;
}

// function getHoursAndMinutes(timeString) {
//     if (!timeString) {
//         return "";
//     }

//     const timeParts = timeString.split(':');
//     let hours = parseInt(timeParts[0], 10);
//     const minutes = timeParts[1];

//     if (hours < 0) {
//         hours = '-' + Math.abs(hours);
//     }

//     return `${hours}h ${minutes}m`;
// }
function getHoursAndMinutes(timeString) {
    if (!timeString) {
        return "";
    }

    const isNegative = timeString.startsWith('-');
    const timeParts = timeString.replace('-', '').split(':'); 

    let hours = parseInt(timeParts[0], 10);
    let minutes = parseInt(timeParts[1], 10);
    let seconds = parseFloat(timeParts[2]); 

    if (hours === 0 && minutes === 0 && seconds > 0) {
        return `0h 00m`;
    }

    return `${isNegative ? '-' : ''}${hours}h ${minutes.toString().padStart(2, '0')}m`;
}


// function isNegativeDeviation(deviation) {
//     if (!deviation) {
//         return ' '
//     }
//     const deviationParts = deviation.split(' ');
//     const hours = parseInt(deviationParts[0]) || 0;
//     const minutes = parseInt(deviationParts[2]) || 0;
//     const totalMinutes = hours * 60 + minutes;
//     return totalMinutes < 0;
// }
function isNegativeDeviation(deviation) {
    if (!deviation) {
        return false;
    }

    // Check if the deviation starts with a negative sign
    const isNegative = deviation.startsWith('-');

    return isNegative;
}

function getDaysDifference(date) {
    const date1 = new Date(date);
    const date2 = new Date();

    const timeDifference = date2.getTime() - date1.getTime();
    const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
    return daysDifference;
}

function GetCurrentMonthStartEndDates() {
    const today = new Date();
    const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    const formatDate = (date) => {
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();
        return `${year}-${month}-${day}`;
    };

    return { startOfMonth: formatDate(startOfMonth), endOfMonth: formatDate(endOfMonth) };
}

export { TextBox, TextArea, SubmitBtn, SubmitButton, IconButton, IsRequired, formatDate, formatTime,formatMonthYear, convertTo12HourFormat, getHoursAndMinutes, isNegativeDeviation, getDaysDifference, GetCurrentMonthStartEndDates };